import React from 'react';

import { FormControlLabel, Grid2 } from '@mui/material';
import { StyledRadio } from '../../styled/radio.input';
import { StyledRadioGroup } from '../../styled/radiogroup.input';

export const YesNoInput = ({ field, design, onChange, value }: any) => {
  return (
    <Grid2>
      <StyledRadioGroup
        name={field.id}
        onChange={onChange}
        value={value}
        design={design}
      >
        <FormControlLabel
          value={'Yes'}
          control={<StyledRadio design={design} size='small' />}
          label={'Yes'}
          sx={{
            transition: 'box-shadow 0.1s linear',
            borderColor:
              value === 'Yes' ? 'transparent' : design.colors.question,
            boxShadow:
              value === 'Yes'
                ? `0 0 0 5px ${design.colors.button}`
                : `0 0 0 1px ${design.colors.question}`,
          }}
        />
        <FormControlLabel
          value={'No'}
          control={<StyledRadio design={design} size='small' />}
          label={'No'}
          sx={{
            transition: 'box-shadow 0.1s linear',
            borderColor:
              value === 'No' ? 'transparent' : design.colors.question,
            boxShadow:
              value === 'No'
                ? `0 0 0 5px ${design.colors.button}`
                : `0 0 0 1px ${design.colors.question}`,
          }}
        />
      </StyledRadioGroup>
    </Grid2>
  );
};
